<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Προσθήκη χρήστη</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Προσθήκη χρήστη
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput label="Ονοματεπώνυμο" addLabelClasses="requiredLabel" type="text" id="name" placeholder="Ονοματεπώνυμο" v-model="name" horizontal></CInput>
              <CInput type="text" label="E-mail" addLabelClasses="requiredLabel" id="email" placeholder="E-mail" v-model="email" horizontal></CInput>
              <CInput type="text" label="Διεύθυνση" addLabelClasses="requiredLabel" id="address" placeholder="Διεύθυνση" v-model="address" horizontal></CInput>
              <CSelect horizontal label="Κατάσταση" addLabelClasses="requiredLabel" id="status" :value.sync="status" :options="[{ value: 'Active', label: 'Active' }, { value: 'Inactive', label: 'Inactive' }, { value: 'Pending', label: 'Pending' }, { value: 'Banned', label: 'Banned' }]" />
              <label class="requiredLabel">Ρόλοι</label>
              <multiselect 
                v-model="roles"
                :value.sync="roles" 
                :options="multiselectOptions" 
                :close-on-select="false"
                id="roles"
                name="roles[]"
                class="mb-3"
                placeholder="Ρόλοι"
                multiple
              ></multiselect>
            <CButton color="primary" @click="store()">Δημιουργία</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'CreateUser',
  props: {
    caption: {
      type: String,
      default: 'Create User'
    },
  },
  components: {
    Multiselect,
  },
  data: () => {
    return {
        multiselectOptions: ["admin", "user", "invoice_user"],
        name: '',
        email: '',
        address: '',
        roles: [],
        status: 'Active',
        showMessage: false,
        message: '',
        alertIsShown: false,
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    store() {
        let self = this;
        axios.post('/api/users?token=' + localStorage.getItem("api_token"),
        {
          name: self.name,
          email: self.email,
          address: self.address,
          roles: JSON.stringify(self.roles).replace(/]|[[""]/g, ''),
          status: self.status,
        })
        .then(function (response) {
            self.name = '';
            self.email = '';
            self.address = '';
            self.roles = [];
            self.status = 'Active';
            self.message = 'Επιτυχής καταχώρηση χρήστη.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    // let self = this;
    // axios.get('/api/users/create?token=' + localStorage.getItem("api_token"))
    // .then(function (response) {
    //     self.statuses = response.data;
    // }).catch(function (error) {
    //     console.log(error);
    //     self.$router.push({ path: 'login' });
    // });
  }
}

</script>
